import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { useKeptWhileReloading } from "./use-kept-while-reloading";

import type { KeptState } from "./use-kept-while-reloading";

/**
 * Assets in the Content Library, across every folder; archiving sets `deleted_at`. Counted again
 * when `refreshKey` changes, keeping the last count meanwhile.
 */
export function useAssetCount(refreshKey: number): KeptState<number> {
  const loaded = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { count, error } = await supabase
        .from("digital_asset")
        .select("id", { count: "exact", head: true })
        .eq("account_id", account_id)
        .is("deleted_at", null);
      if (error) throw error;

      return count ?? 0;
    },
    [refreshKey],
  );

  return useKeptWhileReloading(loaded);
}
